import {Tls} from './Tls'

const BoundTls = {
    minMaxBound: null,
    getNewMinMaxBound() {
        return {
            minX: Infinity,
            maxX: 0,
            minY: Infinity,
            maxY: 0,
            update: function (x, y) {
                if (x > this.maxX) this.maxX = x;
                if (y > this.maxY) this.maxY = y;

                if (x < this.minX) this.minX = x;
                if (y < this.minY) this.minY = y;
            },
            getBound: function () {
                return [Tls.u(this.minX, this.minY), Tls.u(this.maxX, this.maxY)]
            },
            getMiddle: function () {
                return Tls.midPointXY([this.minX,this.minY],[this.maxX,this.maxY]);
                // [Tls.u(this.minX, this.minY), Tls.u(this.maxX, this.maxY)]
            }
        };

    },
    getMinMaxBound() {
        if (!this.minMaxBound) {
            this.minMaxBound = this.getNewMinMaxBound();
        }
        return this.minMaxBound;
    },
    resetMinMaxBound() {
        this.minMaxBound = null;
    }


};

export {BoundTls}